import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';
import { DISCOUNT_DISCOUNT_TYPE } from 'modules/sales-offer/common/constants/offer.type.enum';

export const offerStatusFilter: Filter = {
  field: 'status',
  filter: 'status',
  key: 'status',
  translate: true,
  type: FilterType.FIXED_LIST,
  options: Object.values(OFFER_STATUS)?.map((value) => ({
    value,
    translate: true,
    label: `productDiscount:status.${value}`,
  })),
};

export const discountTypeFilter = (field?: string): Filter => ({
  filter: 'productDiscount:fields.discountType',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'discountType',
  field: field ?? 'discountConfig.type',
  options: Object.values(DISCOUNT_DISCOUNT_TYPE).map((value) => ({
    label: `productDiscount:discountTypes.${value}`,
    translate: true,
    value,
  })),
});

export const discountValueFilter = (field?: string): Filter => ({
  filter: 'productDiscount:fields.discount',
  translate: true,
  type: FilterType.NUMBER,
  key: 'discountValue',
  field: field ?? 'discountConfig.value',
});

export const startDateFilter: Filter = {
  filter: 'productDiscount:fields.fromDate',
  translate: true,
  type: FilterType.DATE,
  key: 'fromDate',
  field: 'fromDate',
};

export const endDateFilter: Filter = {
  filter: 'productDiscount:fields.toDate',
  translate: true,
  type: FilterType.DATE,
  key: 'toDate',
  field: 'toDate',
};

export const productDiscountFilters = [
  offerStatusFilter,
  discountValueFilter(),
  discountTypeFilter(),
  startDateFilter,
  endDateFilter,
  createdATFilter,
];
